import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { offCanvaChange, sideBarChange } from "../Reducer/componentSlice"
import { useAuth } from "../Contexts/AuthenticateProvider"
import { DropdownToggle, DropdownButton } from '../Helpers/Components/Dropdown';
import { useLocation, useNavigate } from "react-router-dom";
import { deleteAllCookies } from "../Helpers/Utils";
const EVENTS = ["mousemove", "mousedown", "click", "scroll", "keydown", "touchstart",];

const Header = () => {
  const { logOut, userDetails, request } = useAuth()
  const dispatch = useDispatch()
  const component = useSelector((state) => state.component)
  const [width, setWidth] = useState(window.innerWidth);
  const location = useLocation()
  const timeout = 1260000
  const navigate = useNavigate()
  const changeBar = () => { dispatch(sideBarChange(!component?.sideBar)) }
  const intervalRef = useRef(null);
  const logoutCalled = useRef(false);
  const [remainingTime, setRemainingTime] = useState(null);
  const updateActivity = () => {
    logoutCalled.current = false;
    localStorage.setItem("lastActivity", Date.now().toString());
  };
  useEffect(() => {
    if (!localStorage.getItem("lastActivity")) { updateActivity(); }
    EVENTS.forEach((event) => { window.addEventListener(event, updateActivity); });
    intervalRef.current = setInterval(() => {
      const lastActivity = Number(localStorage.getItem("lastActivity") || Date.now());
      const idleTime = Date.now() - lastActivity;
      const remaining = timeout - idleTime;
      if (remaining <= 60000 && remaining > 0) { setRemainingTime(Math.ceil(remaining / 1000)); } else { setRemainingTime(0) }
      if (idleTime >= timeout && !logoutCalled.current) {
        logoutCalled.current = true;
        localStorage.setItem("logout", Date.now().toString())
        logOut()
      }
    }, 1000);
    const handleStorage = (e) => {
      if (e.key === "logout") {
        logoutCalled.current = true;
        deleteAllCookies();
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace("/login");
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => {
      EVENTS.forEach((event) => window.removeEventListener(event, updateActivity));
      window.removeEventListener("storage", handleStorage);
      clearInterval(intervalRef.current);
    };
  }, []);
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])
  useEffect(() => {
    if (width < 992) {
      if (component.offCanva === false) {
        dispatch(sideBarChange(true))
      }
      dispatch(offCanvaChange(true))
    } else {
      dispatch(offCanvaChange(false))
    }
  }, [width])
  return (
    <React.Fragment>
      <header className="header">
        {width > 991 ?
          <>
            <div className={`header-content ${component.sideBar ? "header-content-lg" : "header-content-sm"}`}>
              <div className="d-flex justify-content-center align-items-center">
                <i className="fa-solid fa-bars menu-btn cursor-pointer fs-5" onClick={changeBar}></i>
              </div>
              <div className="d-flex justify-content-center align-items-center mx-4 gap-3">
                <div className="fs-5 fw-medium"> {remainingTime ? remainingTime : "Active"}</div>
                <button style={location.pathname.includes("/request") ? { color: '#ff4d32' } : { color: '#000' }} className={`${request ? "offer-blink" : ""} btn request-btn`} onClick={() => navigate(`/request/all/1`)}><i className="fa-solid fa-hand"></i> Request</button>
                <DropdownToggle label={userDetails?.name ? userDetails?.name?.toUpperCase() : "Buddy"}>
                  <DropdownButton label="Logout" onClick={logOut} />
                </DropdownToggle>
              </div>
            </div>
          </>
          :
          <div className="d-flex w-100 p-5 gap-4 justify-content-end align-items-center">
            <div className="fs-5 fw-medium"> {remainingTime ? remainingTime : "Active"}</div>
            <i className="fa-solid fa-bars cursor-pointer fs-5" onClick={changeBar}></i>
          </div>
        }
      </header>
    </React.Fragment>
  );
};

export default Header;
